module.exports = __webpack_public_path__ + "img/cooperate_qy_06@2x.f51fd07c.png";